import { render, staticRenderFns } from "./showRowNumber-editor.vue?vue&type=template&id=148dc69b&scoped=true&"
import script from "./showRowNumber-editor.vue?vue&type=script&lang=js&"
export * from "./showRowNumber-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148dc69b",
  null
  
)

export default component.exports